import { render, staticRenderFns } from "./SupportWMC.vue?vue&type=template&id=02d516c8&scoped=true&"
import script from "./SupportWMC.vue?vue&type=script&lang=js&"
export * from "./SupportWMC.vue?vue&type=script&lang=js&"
import style0 from "./SupportWMC.vue?vue&type=style&index=0&id=02d516c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d516c8",
  null
  
)

export default component.exports